import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Modal } from "../../ui/Modal";

/*
 *
 * Enhanced-Visualizations gated by the CALLER (it is never mounted when the preference is off), the
 * same rule as every other animation.
 */
export const SAVING_MS = 2000;

export function SavingSoilMapNote({
  fieldCount,
  onClose,
}: {
  fieldCount: number;
  onClose: () => void;
}) {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const t0 = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      const p = Math.min(1, (now - t0) / SAVING_MS);
      setPct(p);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  const done = pct >= 1;
  // THE SAME POP-UP FRAME AS EVERY OTHER ANIMATION — "it should appear as a pop-u window just like
  // all the other animations") — fixed overlay, centred card, X top-right that only.
  return (
    <Modal>
      <div
        className="fixed inset-0 z-overlay flex items-center justify-center bg-black/60 p-4"
        role="status"
        aria-live="polite"
      >
        <div className="relative flex w-full max-w-lg flex-col gap-2 rounded-lg bg-surface p-4 text-fg shadow-2xl">
          <button
            onClick={onClose}
            aria-label="Close"
            className="absolute right-2 top-2 rounded p-1 text-muted hover:bg-hover hover:text-fg"
          >
            <X size={16} />
          </button>
          <h2 className="pr-6 text-center text-[15px] font-semibold">
            Saving as Soil Map
          </h2>
          <p className="text-center text-[12px] text-muted">
            {done
              ? `Saved — the zone map is building in the background and will show as the most recent soil map${fieldCount > 1 ? ` on all ${fieldCount} fields` : ""}. You can close this window.`
              : `Turning your zones into ${fieldCount > 1 ? `${fieldCount} soil maps` : "a soil map"}…`}
          </p>
          <div
            className="mx-auto mt-2 h-2.5 w-full max-w-sm overflow-hidden rounded bg-line"
            aria-hidden
          >
            <div
              className="h-full rounded bg-accent transition-[width] duration-100"
              style={{ width: `${Math.round(pct * 100)}%` }}
            />
          </div>
          <progress
            className="sr-only"
            max={100}
            value={Math.round(pct * 100)}
            aria-label="Saving as Soil Map"
          />
        </div>
      </div>
    </Modal>
  );
}
